import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;
// Obtener el objeto de auth desde localStorage y extraer el api_token
const storedAuth = localStorage.getItem('kt-auth-react-v');
let token = '';

if (storedAuth) {
  const parsedAuth = JSON.parse(storedAuth);
  token = parsedAuth.api_token;
}

// Crear instancia de axios con el token
const axiosInstance = axios.create({
  baseURL: API_URL,
  timeout: 10000, // Tiempo de espera (10 segundos)
  headers: {
    'Authorization': `Bearer ${token}`,
  },
});

// Función para obtener datos de monitoreo
export function getMonitoring(suscriptionId: any, cloud?: any, region?: any) {
  return axiosInstance.get(`/v1/monitoring/${suscriptionId}/instances`, {
    params: { cloud, region },
  });
}

// Función para obtener datos de monitoreo por tenant
export function getMonitoringtenant(suscriptionId: any, tenant: any, cloud?: any, region?: any) {
  return axiosInstance.get(`/v1/monitoring/${suscriptionId}/instances`, {
    params: { tenantId: tenant, cloud, region },
  });
}
